import React from 'react'
import { FormFieldProps } from './types'

/**
 * Componente FormField - Wrapper minimalista con label, error, required
 * Diseño limpio y sutil con soporte para iconos Heroicons
 */
const FormField: React.FC<FormFieldProps> = ({
  label,
  required = false,
  error,
  helpText,
  children,
  className = '',
  labelClassName = '',
  htmlFor,
  icon: Icon,
}) => {
  return (
    <div className={`mb-2 ${className}`}>
      {/* Label minimalista con icono opcional */}
      {label != null && label !== '' && (
        <label
          htmlFor={htmlFor}
          className={`flex flex-wrap items-center gap-x-1.5 gap-y-0.5 text-sm font-medium text-gray-700 mb-1.5 ${error ? 'text-red-600' : ''} ${labelClassName}`}
        >
          {Icon && (
            <Icon className="h-4 w-4 text-gray-500 flex-shrink-0" />
          )}
          <span className="inline-flex flex-wrap items-baseline gap-x-1.5 gap-y-0">
            {label}
            {required && <span className="text-red-500">*</span>}
          </span>
        </label>
      )}

      {/* Campo */}
      <div className="relative">
        {children}
      </div>

      {/* Texto de ayuda - minimalista */}
      {helpText && !error && (
        <p className="mt-1 text-xs text-gray-500">{helpText}</p>
      )}

      {/* Mensaje de error (si el componente hijo no lo muestra) */}
      {error && typeof children !== 'object' && (
        <div className="mt-1 flex items-center gap-1">
          <span className="text-xs text-red-600">{error}</span>
        </div>
      )}
    </div>
  )
}

export default React.memo(FormField)
